import * as types from "./types";

export function getComunicadoCodigoTelaRequest(codigoTela) {
  return {
    type: types.GET_COMUNICADO_CODIGO_TELA_REQUEST,
    payload: { codigoTela },
  };
}

export function getComunicadoCodigoTelaSuccess(payload) {
  return {
    type: types.GET_COMUNICADO_CODIGO_TELA_SUCCESS,
    payload,
  };
}

export function comunicadoTelaClose() {
  return {
    type: types.COMUNICADO_TELA_CLOSE,
  };
}
